<template>
	<div
		class="courseVideo"
		:style="{
			marginTop: data.marginTop + 'px',
			paddingTop: data.paddingTop + 'px',
			paddingLeft: data.paddingLeft + '%',
			paddingRight: data.paddingRight + '%',
		}"
	>
		<div v-show="data.styleSelect == 'is_style_ly'">
			<img src="../../assets/img/ly/l2.png" class="desc1" />
			<div class="desc-box">
				<div class="desc-detail">
					<div
						class="desc-text"
						v-if="data.content"
						:style="{
							color: data.textColor,
							fontSize: data.fontSize + 'px',
							fontWeight: data.fontWeight,
							lineHeight: data.fontLineHeight + 'px',
							textAlign: data.textAlign,
						}"
					>
						{{ data.content }}
					</div>
					<div class="desc-text" v-else>
						感冒：感受风邪或时行疫毒，引起肺卫功能失 调的一种外感病证。 可辨证为风寒感冒、风热 感冒、暑湿感冒、时行感冒等。 疰夏：暑湿之气外侵，困阻脾胃或暑热耗伤 正气，脾失健运所致病证。
						痢疾：外感时邪疫毒，内伤饮食不洁所致的 秋燥：秋季感受燥邪而发生的干燥症状，分 为温燥和凉燥两种。 咳嗽：中医辨证为肺气不清，失于宣肃，上 逆作声而引起。
					</div>
				</div>
			</div>
			<img src="../../assets/img/ly/l4.png" class="desc1" />
		</div>
		<div v-show="data.styleSelect == 'is_style_gf'">
			<img src="../../assets/img/gf-ver1/gfbk2.png" class="desc1" />
			<div class="gf-desc-detail">
				<div
					class="desc-text"
					v-if="data.content"
					:style="{
						color: data.textColor,
						fontSize: data.fontSize + 'px',
						fontWeight: data.fontWeight,
						lineHeight: data.fontLineHeight + 'px',
						textAlign: data.textAlign,
					}"
				>
					{{ data.content }}
				</div>
				<div class="desc-text" v-else>
					虚劳：由于禀赋薄弱、后天失养及外感内伤等多种原因引起的慢性衰弱证候的总称。
					郁证：由于情志不舒、气机郁滞所致，以心情抑郁、情绪不宁、胸部满闷、胸胁胀痛，或易怒易哭，或咽中如有异物梗塞等为主要临床表现的一类病证。
					瘀证：由于血液运行不畅，瘀积凝滞，或离经之血停积体内，或久病入络等所致的多种病证的总称。
					水肿：因人体的水液不能正常地输布或者排泄而聚集于体内导致的一种疾病，与肺、脾、肾以及三焦相关。
				</div>
			</div>
			<img src="../../assets/img/gf-ver1/gfbk4.png" class="desc1" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'courseVideo',
	props: ['data'],
	mounted() {},
	methods: {},
};
</script>

<style lang="scss" scoped>
// @import '../../assets/css/curriculum.scss';
.desc1,
.desc2 {
	width: 100%;
	height: 100%;
	display: block;
}

.desc-box {
	width: 100%;
	background: url('../../assets/img/ly/l5.png') no-repeat;
	background-size: 100% 100%;
}
.desc-detail {
	width: 90%;
	padding: 10px 20px;
	margin: 0 auto;
	background: url('../../assets/img/ly/l7.png') no-repeat;
	background-size: 100% 100%;
	box-sizing: border-box;
}

.desc-text {
	font-size: 14px;
	font-weight: 500;
	color: #7c5401;
	line-height: 22px;
	margin-top: 10px;
	white-space: pre-line;
	word-break: break-all;
}
.gf-desc-detail {
	width: 100%;
	padding: 0 30px;
	margin: 0 auto;
	background: url('../../assets/img//gf-ver1/gfbk3.png') no-repeat;
	background-size: 100% 100%;
	box-sizing: border-box;
}
.gf-desc-detail .desc-text {
	margin-top: 0;
}
</style>